<div class="flex flex-col gap-6 px-4 pt-[10px]">
   @if (isLoadingReportingPeriods) {
      <app-basic-loader class="mt-[150px]"></app-basic-loader>
   } @else {
      <div class="flex gap-2 items-end text-sm">
         <span class="font-bold">{{ 'project_duration' | translate }}:</span>
         <span>{{ project?.duration ?? '-' }} {{ 'months' | translate }}</span>
      </div>
      <div class="basic-row-divider"></div>
      <div class="flex flex-col gap-10">
         @if (project && project.startDate && nextStartMonthFC && nextStartMonthFC.value < project.duration) {
            <div class="flex gap-5 items-start">
               <app-basic-input
                  [id]="'reporting-next-period-input'"
                  [disabled]="true"
                  [inputFC]="nextPeriodFC"
                  [label]="'period' | translate"
               >
               </app-basic-input>
               <app-basic-input
                  [id]="'reporting-next-start-month-input'"
                  [disabled]="true"
                  [inputFC]="nextStartMonthFC"
                  [label]="'start_month' | translate"
               >
               </app-basic-input>
               <div class="flex flex-col">
                  <app-basic-input
                     [id]="'reporting-end-month-input'"
                     [maxLength]="100"
                     [type]="'number'"
                     [required]="true"
                     [inputFC]="endMonthFC"
                     [label]="'end_month' | translate"
                     [disabled]="nextStartMonthFC && project && nextStartMonthFC.value >= project.duration"
                  >
                  </app-basic-input>
                  @if (endMonthFC?.touched && endMonthFC?.invalid) {
                     <span class="input-error-message">{{ getErrorMessage(endMonthFC) | translate }}</span>
                  }
               </div>
               <p-button
                  class="pt-[23px]"
                  styleClass="basic-accent-1-button w-[120px] h-[38px] whitespace-nowrap font-semibold "
                  label="Add"
                  [disabled]="project && (endMonthFC?.value > project.duration || nextStartMonthFC.value >= project.duration)"
                  (click)="project && (endMonthFC?.value > project.duration || nextStartMonthFC.value >= project.duration) ? null : addReportClick.emit()"
               >
               </p-button>
            </div>
         }
         @if (reportingPeriodsRes?.reportingPeriods?.length) {
            <div>
               <div class="flex flex-col gap-[40px]">
                  <app-basic-reporting-period-table
                     [height]="'280px'"
                     [reportingPeriodsArray]="reportingPeriodsRes?.reportingPeriods"
                     (deleteReportClick)="deleteReportClick.emit()"
                  ></app-basic-reporting-period-table>
                  @if (nextStartMonthFC && project && nextStartMonthFC.value < project.duration) {
                     <div class="flex gap-5 items-center justify-center">
                        <span class="pi pi-exclamation-triangle text-[30px] text-red-500"></span>
                        <div class="flex gap-1 text-sm">
                           <span>{{ 'reporting_periods_still_missed' | translate }}</span>
                           <span class="font-bold text-red-500">{{ project.endDate ? (project.endDate | date: 'dd/MM/YYYY') : '-' }}</span>
                        </div>
                     </div>
                  }
               </div>
            </div>
         } @else {
            <div class="flex gap-5 items-center justify-center {{ !project?.startDate ? 'pt-4' : '' }}">
               <span class="pi pi-exclamation-triangle text-[30px] text-red-500"></span>
               <span class="font-bold text-sm">{{
                  !project?.startDate ? ('reporting_start_date_not_set' | translate) : ('no_reporting_available' | translate)
               }}</span>
            </div>
         }
      </div>
   }
</div>
